import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@/hooks/useAuth';
import { keys } from '@/lib/queryKeys';
import { fetchInventory } from './api';
import type { InventoryFilter } from './types';

/**
 * Branch-scoped — see HMS_V4_API_CONTRACT.md §5 for why branchVersion is appended.
 *
 * A selling screen passes its `channel` so it only offers stock it can sell
 * (the channel's store — the server refuses any other batch anyway). No filter
 * reads every store at the branch. The filter is appended AFTER
 * keys.pharmacy.inventory(), so every existing invalidation of that prefix
 * still refreshes all filtered variants.
 */
export function useInventory(filter: InventoryFilter = {}) {
  const { branchVersion } = useAuth();
  return useQuery({
    queryKey: [...keys.pharmacy.inventory(), filter.channel ?? null, filter.storeId ?? null, branchVersion],
    queryFn: () => fetchInventory(filter),
  });
}
